
import { useCallback, useState } from 'react';

export function useMoneyInput() {
  const formatNumber = useCallback((num: number): string => {
    if (num === 0) return '';
    return new Intl.NumberFormat('en-IE', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(num);
  }, []);

  const parseNumber = useCallback((input: string): number => {
    const cleaned = input.replace(/[^0-9.]/g, '');
    return cleaned === '' ? 0 : parseFloat(cleaned);
  }, []);

  // This function helps calculate where the cursor should be after formatting
  const calculateCursorPosition = useCallback((originalValue: string, formattedValue: string, currentPosition: number): number => {
    // Count how many format characters (commas, spaces) are before the cursor in the original value
    const originalBeforeCursor = originalValue.substring(0, currentPosition);
    const formatCharCountBeforeCursor = (originalBeforeCursor.match(/[^0-9.]/g) || []).length;
    
    // Find the corresponding position in the formatted string
    const valueWithoutFormatting = originalValue.replace(/[^0-9.]/g, '');
    const plainTextBeforeCursor = originalBeforeCursor.replace(/[^0-9.]/g, '');
    const plainTextPosition = plainTextBeforeCursor.length;
    
    // Count format chars in new string up to the equivalent plain text position
    let newPosition = plainTextPosition;
    for (let i = 0, j = 0; i < formattedValue.length && j < plainTextPosition; i++) {
      if (/[0-9.]/.test(formattedValue[i])) {
        j++;
      }
      newPosition = i + 1;
    }
    
    return newPosition;
  }, []);

  return {
    formatNumber,
    parseNumber,
    calculateCursorPosition
  };
}
